import { ECustomFieldType } from '../../../custom-fields/custom-field-types-enums';
import { GET_CUSTOM_FIELDS } from '../../../custom-fields/custom-fields.store';
import { EUserRole } from '../../share-utils/user-roles';
import { TCustomFieldAccessOption } from '../../share.model';

export function getWorkspaceCustomFieldsPermissions({
  workspaceCustomFields,
  permissionRead,
  permissionEdit,
  shareOption,
}: {
  workspaceCustomFields: string[];
  permissionRead: boolean;
  permissionEdit: boolean;
  shareOption: EUserRole;
}): TCustomFieldAccessOption[] {
  return workspaceCustomFields.map((customFieldId) => {
    const customField = GET_CUSTOM_FIELDS()[customFieldId];
    const isNormalUserSignature =
      shareOption === EUserRole.NORMAL && customField.type === ECustomFieldType.SIGNATURE;

    return {
      templateId: customFieldId,
      permission: {
        read: permissionRead,
        edit: permissionEdit && !customField.lockedValue && !isNormalUserSignature,
      },
    };
  });
}
